/* eslint-disable */
import React, { Component } from "react";
import "./App.scss";
import { UserProvider } from "./components";
import { TestingPage, Login } from "./scenes";

class App extends Component {
  // async componentDidMount() {}
  async componentDidMount(){
    if (location.protocol !== 'https:' && !window.location.hostname.includes('localhost')) {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
  }

  render() {
    return (
      <UserProvider
        render={({ isLoggedIn, userData }, login, logout) =>
          isLoggedIn ? <TestingPage logout={logout} /> : null
        }
      />
    );
  }
}

export default App;
